module.exports = __webpack_public_path__ + "static/Icons_CurrentHO_Homeloan_Large-07f501f6e37417f3269915b71ebd743f.png";